import requests from "./httpService";

const UserServices = {
  getUsernames(id, startDate, endDate) {
    let url = `/username?company_id=${id}`;
    if (startDate && endDate) {
      url += `&startDate=${startDate}&endDate=${endDate}`;
    }
    return requests.get(url);
  },

  getMentionUsers(id, body) {
    return requests.get(`/user/note-mentions?company_id=${id}`, body);
  },

  getCrmLeadMentionUsers(id, body) {
    return requests.get(`/user/crm-lead-mentions?company_id=${id}`, body);
  },

  getDepartmentUsernames(id, body) {
    return requests.get(`/username/departmentuser?company_id=${id}`, body);
  },

  getUserSummary(id, body) {
    return requests.get(`/summary/users?company_id=${id}`, body);
  },

  getUserLeaveRequest(id, body) {
    return requests.get(`/summary/leavesrequest?company_id=${id}`, body);
  },

  getUserHomeAttendence(id, body) {
    return requests.get(`/homeattendence/users?company_id=${id}`, body);
  },
  getUserHomeAttendenceGraph(id, body) {
    return requests.get(`/homeattendence/graph?company_id=${id}`, body);
  },

  getUserPermissions(id) {
    return requests.get(`/roles/userPermissions?company_id=${id}`);
  },

  updateWelcomeSeen(id) {
    return requests.post(`/user/update-welcome-seen/${id}`);
  },

  refreshToken() {
    return requests.post(`/user/refresh-token`);
  },
  getCompanyActiveUsers(id) {
    return requests.get(`/user/company-active-users?company_id=${id}`);
  },
  getHolidaysActiveUsers(id) {
    return requests.get(`/user/holidays-active-users?company_id=${id}`);
  },
  getProjectUsers(id) {
    return requests.get(`/username/project-users?company_id=${id}`);
  },
  getWfhHrUsernames(id) {
    return requests.get(`/username/wfh-hr?company_id=${id}`);
  },
  getWfhTeamUsernames(id) {
    return requests.get(`/username/wfh-team?company_id=${id}`);
  },
};

export default UserServices;
